/**
 * Liste LLM $/dk (katalog, ×1.5 dahil ham oran) → müşteriye yansıyan $/dk.
 * AgentEditor üst metrik ile aynı formül.
 *
 * @param {number} rawListUsdPerMin
 * @param {number} aiUsageCommissionPercent — örn. site.aiUsageCommission
 * @returns {number}
 */
export function customerLlmUsdPerMinuteFromList(rawListUsdPerMin, aiUsageCommissionPercent) {
    var raw = Number(rawListUsdPerMin);
    if (!raw || isNaN(raw)) {
        return 0;
    }
    var stableCommissionRate = 1.2;
    var aiCallCommissionRate = Math.max(Number(aiUsageCommissionPercent) / 100, 0);
    var totalCommissionRate = stableCommissionRate + aiCallCommissionRate;
    var stableLlmPrice = raw * stableCommissionRate;
    var totalLlmPrice = raw * totalCommissionRate;
    return Math.max(totalLlmPrice, stableLlmPrice);
}

/** ElevenLabs ses modeli $/dk (yalnızca UI gösterimi) */
var ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE = {
    eleven_turbo_v2_5: 0.04,
    eleven_flash_v2_5: 0.04,
    eleven_multilingual_v2: 0.06,
    eleven_v3: 0.2,
};

/**
 * @param {string} [voiceModelId] agent.voice_model
 * @returns {number}
 */
export function getElevenLabsVoiceModelUsdPerMinute(voiceModelId) {
    if (!voiceModelId) {
        return ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE.eleven_multilingual_v2;
    }
    var id = String(voiceModelId).trim();
    if (Object.prototype.hasOwnProperty.call(ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE, id)) {
        return ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE[id];
    }
    return ELEVENLABS_VOICE_MODEL_USD_PER_MINUTE.eleven_multilingual_v2;
}
